import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Hidden, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GridOnIcon from '@material-ui/icons/GridOn';
import ViewDayIcon from '@material-ui/icons/ViewDay';

import { FeedViewOptions } from 'types/app';
import { useReleases } from 'hooks';

interface Props {
  activeView: FeedViewOptions;
  onChange: () => void;
}

const useStyles = makeStyles(theme => ({
  iconButton: {
    backgroundColor: theme.palette.common.white,
  },
}));

const TimelineHeader: FC<Props> = ({ activeView, onChange }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const releases = useReleases();

  const hasGridView = releases.includes('GridViewWeb');

  function renderViewOptions() {
    if (!hasGridView) {
      return null;
    }

    return (
      <Hidden mdDown>
        <Grid item>
          <IconButton id="feed-view-switch" onClick={onChange} className={classes.iconButton}>
            {activeView === FeedViewOptions.List ? <GridOnIcon /> : <ViewDayIcon />}
          </IconButton>
        </Grid>
      </Hidden>
    );
  }

  return (
    <Hidden mdDown>
      <Grid container alignItems="center">
        <Grid item xs>
          <Typography variant="h4" color="textSecondary">
            {t('components:timeline')}
          </Typography>
        </Grid>
        {renderViewOptions()}
      </Grid>
    </Hidden>
  );
};

export default TimelineHeader;
